import ResultItem from "./resultItem";
import { CLOSE, NORMAL, STOP_RULESET } from "./resultTypes";

const create = ResultItem.create;

export const ACTION_RESULT_CLOSE = create(CLOSE);
export const ACTION_RESULT_NORMAL = create(NORMAL);
export const ACTION_RESULT_STOP_RULESET = create(STOP_RULESET);